module.exports = __webpack_public_path__ + "static/media/card-platinum.d499b1ce.png";